var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSubServicesFallbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43.4598C22.6081 43.8109 23.2979 43.9957 24 43.9957C24.7021 43.9957 25.3919 43.8109 26 43.4598L40 35.4598C40.6075 35.1091 41.112 34.6048 41.4631 33.9975C41.8141 33.3902 41.9993 32.7013 42 31.9998V15.9998C41.9993 15.2984 41.8141 14.6094 41.4631 14.0021C41.112 13.3948 40.6075 12.8905 40 12.5398L26 4.5398C25.3919 4.18873 24.7021 4.00391 24 4.00391C23.2979 4.00391 22.6081 4.18873 22 4.5398L8 12.5398C7.39253 12.8905 6.88796 13.3948 6.53692 14.0021C6.18589 14.6094 6.00072 15.2984 6 15.9998V31.9998C6.00072 32.7013 6.18589 33.3902 6.53692 33.9975C6.88796 34.6048 7.39253 35.1091 8 35.4598L22 43.4598Z",
    stroke: "#D1D5DC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44V24",
    stroke: "#D1D5DC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58008 14L24.0001 24L41.4201 14",
    stroke: "#D1D5DC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.54004L33 18.84",
    stroke: "#D1D5DC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubServicesFallbackIcon);
export default __webpack_public_path__ + "static/media/no-sub-services-fallback-icon.22cb488a1857262ccfd7d7d7e3d265c7.svg";
export { ForwardRef as ReactComponent };